import { getNetworkSettings } from "../network/NetworkSettings.ts";
import { NetworkError } from "../network/types.ts";
export type SourceTransportMode = "worker" | "extension";
type TokenReader = (options?: { skipCache?: boolean }) => Promise<string | null>;
let userId: string | null = null;
let tokenReader: TokenReader | undefined;
let epoch = 0;
export const hasSourceSession = () => !!userId && !!tokenReader;
export const WORKER_TEST_USER_ID = 'user_3Ke31MeSmOlKy0Ny0sbpWfzutNd';
export const hasWorkerTestAccess = () => false;
export const getAuthSessionKey = () => JSON.stringify([epoch, userId || "guest"]);
// Compatibility/UI hint only. Actual per-request decisions belong to TransportRouter.
export const getSourceTransport = (): SourceTransportMode => "extension";
export const getSourceCacheScope = () =>
  JSON.stringify([
    epoch,
    userId || "guest",
    getNetworkSettings(),
    typeof document !== "undefined" ? (document.documentElement?.dataset.yomiriBridgeId ?? "") : "",
  ]);
export function configureSourceSession(id: string | null, reader?: TokenReader) {
  const changed = userId !== id || !!tokenReader !== !!(id && reader);
  userId = id;
  tokenReader = id ? reader : undefined;
  if (changed) {
    epoch++;
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("yomiri-transport-changed"));
      window.dispatchEvent(new Event("yomiri-sources-changed"));
    }
  }
}
export async function getWorkerToken(skipCache = false) {
  const expectedUser = userId;
  const expectedEpoch = epoch;
  const token = await tokenReader?.({ skipCache });
  if (!userId || userId !== expectedUser || epoch !== expectedEpoch || !token)
    throw new NetworkError(
      "LOGIN_REQUIRED",
      "Tu sesión venció o cambió. Volvé a iniciar sesión para probar el Worker.",
    );
  return token;
}
